import { render, staticRenderFns } from "./LatestEventCard.vue?vue&type=template&id=9af4f048"
import script from "./LatestEventCard.vue?vue&type=script&lang=js"
export * from "./LatestEventCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImageFill: require('/vercel/path0/components/ImageFill.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
